<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar egreso</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.expenseName"
                                :error="getError('detalle')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.expenseQty"
                                :error="getError('cantidad')"
                                v-model="expenseQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor unidad</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="valor unidad" v-validate="modelValidations.expenseValue" :error="getError('valor unidad')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                    <span v-show="errors.has('valor unidad')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valor unidad') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  disabled :max=9999999999999 tabindex="8" currency="$" autocomplete="off" name="total" v-validate="modelValidations.expenseTotal" :error="getError('total')" separator="." class="form-control" v-model="expenseTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Periodicidad</label>
                    <fg-input   tabindex="1"
                                name="periodicidad"
                                v-validate="modelValidations.expensePeriodicity"
                                :error="getError('periodicidad')"
                                v-model="expensePeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="expensePeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Seleccionar mes"
                                    label="Seleccionar mes">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="expensePeriodicity == 'Seleccionar mes'" class="form-group">
                    <label>Seleccione mes (Periodicidad)</label>
                    <el-date-picker
                        v-model="expensePeriodicityDate"
                        type="month"
                        placeholder="Seleccione mes (periodicidad)">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad</label>
                    <el-date-picker
                        v-model="expenseDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar egreso</h6>
            <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.expenseName"
                                :error="getError('detalle')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.expenseQty"
                                :error="getError('cantidad')"
                                v-model="expenseQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor unidad</label>
                    <vue-numeric  :max=999999999 tabindex="8" currency="$" autocomplete="off" name="valor unidad" v-validate="modelValidations.expenseValue" :error="getError('valor unidad')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                    <span v-show="errors.has('valor unidad')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valor unidad') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  disabled :max=99999999999999 tabindex="8" currency="$" autocomplete="off" name="total" v-validate="modelValidations.expenseTotal" :error="getError('total')" separator="." class="form-control" v-model="expenseTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Periodicidad</label>
                    <fg-input   tabindex="1"
                                name="periodicidad"
                                v-validate="modelValidations.expensePeriodicity"
                                :error="getError('periodicidad')"
                                v-model="expensePeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="expensePeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Seleccionar mes"
                                    label="Seleccionar mes">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="expensePeriodicity == 'Seleccionar mes'" class="form-group">
                    <label>Seleccione mes (Periodicidad)</label>
                    <el-date-picker
                        v-model="expensePeriodicityDate"
                        type="month"
                        placeholder="Seleccione mes (periodicidad)">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad</label>
                    <el-date-picker
                        v-model="expenseDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">EGRESOS TOTALES DE LA UNIDAD PRODUCTIVA AGROPECUARIA</h6>
            </div>
            <div class="card-body">
                <a href="#" @click.prevent="generateProducts()" class="top-right-button mr-4">
                    Restablecer productos
                </a>
                <el-table @expand-change="handleExpandChange" v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table  @expand-change="handleExpenseExpandChange" ref="expensesTable"  highlight-current-row @current-change="handleCurrentExpenseChange" v-if="props.row.expenses.length > 0" :data="props.row.expenses">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <p>Detalle:{{ props.row.expenseName }}</p>
                                        <p>Cantidad: {{ props.row.expenseQty }}</p>
                                        <p>Valor unidad: {{ setFormat(props.row.expenseValue) }}</p>
                                        <p>Total: {{ setFormat(props.row.expenseTotal) }}</p>
                                        <p>Periodicidad: {{ props.row.expensePeriodicity }}</p>
                                        <p>Mes seleccionado (Periodicidad): {{ formatDate(props.row.expensePeriodicityDate) }}</p>
                                        <p>Mes inicio periodicidad: {{ formatDate(props.row.expenseDate) }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Concepto" property="expenseName"></el-table-column>
                                <el-table-column label="Total">
                                    <template slot-scope="scope">
                                        <span >{{ setFormat(scope.row.expenseTotal )}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br>
                            <p-button 
                                @click="addProductMethod(props.$index, props.row)"
                                type="default" 
                                >
                                <i class="mr-2 fa fa-plus"></i>Agregar egreso
                            </p-button>
                            <br>
                            <p-button class="mt-2" v-if="currentExpenseRow"
                                @click="editProductMethod(props.$index, props.row)"
                                type="default" 
                                >
                                <i class="mr-2 fa fa-pencil"></i>Editar egreso
                            </p-button>
                            <br>
                            <p-button class="mt-2" v-if="currentExpenseRow"
                                @click="removeProductMethod(props.$index, props.row)"
                                type="default" 
                                >
                                <i class="mr-2 fa fa-minus"></i>Quitar egreso
                            </p-button>
                            
                            <div class="alert alert-warning mt-2">
                                <span>Valor total egresos: {{ setFormat(props.row.expenseTotal)}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Unidad productiva" property="name"></el-table-column>
                </el-table>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            cashFlowData: null,
            seasonalSales: [],
            historicalYields: [],
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            currentExpenseRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            editProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseQty: '',
            expenseValue: '',
            expenseTotal: '',
            expensePeriodicity: '',
            expensePeriodicityDate: '',
            expenseDate: '',
            referenceDescription: '',
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                expenseName: {
                    required: true,
                    max: 50,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/

                },
                expenseQty: {
                    required: false,
                    max: 7
                },
                expenseValue: {
                    required: false
                },
                expenseTotal: {
                    required: false
                },
                expensePeriodicity: {
                    required: false
                },
                expensePeriodicityDate: {
                    required: false
                },
                expenseDate: {
                    required: false
                }
            },
        }
        },
        watch: {
            expensePeriodicity: function(newVal) {
                if (newVal != 'Seleccionar mes') {
                    this.expensePeriodicityDate = '';
                }
            }
           
        },
        computed: {

            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            expenseTotalComputed () {
                if(this.expenseValue != '' && this.expenseQty != '') {
                    this.expenseTotal = parseFloat(this.expenseValue) * parseFloat(this.expenseQty);
                    return this.expenseTotal;
                }
                else {
                    this.expenseTotal = 0;
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            calculateTotalizedExpenses(updatedMonths, totalizedExpenses) {
                console.log("📢 Calculando totalizados de expenses...");

                // Reiniciar los valores totalizados en 0 antes de acumular
                totalizedExpenses.historical.forEach(p => p.totalizedExpense = 0);
                totalizedExpenses.seasonal.forEach(p => p.totalizedExpense = 0);

                // Recorrer todos los meses y sumar los expenses de cada producto
                updatedMonths.forEach(month => {
                    console.log(`🛠️ Procesando mes: ${month.name}`);

                    // 🔹 Sumar los históricos
                    month.historicalExpenses.forEach(expense => {
                        let productTotalized = totalizedExpenses.historical.find(p => p.productName === expense.productName);
                        if (productTotalized) {
                            productTotalized.totalizedExpense += expense.expenseTotal;
                            console.log(`💰 ${expense.productName} (historical) suma: ${expense.expenseTotal}`);
                        }
                    });

                    // 🔹 Sumar los estacionales
                    month.seasonalExpenses.forEach(expense => {
                        let productTotalized = totalizedExpenses.seasonal.find(p => p.productName === expense.productName);
                        if (productTotalized) {
                            productTotalized.totalizedExpense += expense.expenseTotal;
                            console.log(`💰 ${expense.productName} (seasonal) suma: ${expense.expenseTotal}`);
                        }
                    });
                });

                console.log("✅ Totalizados calculados correctamente:", totalizedExpenses);
                return totalizedExpenses;
            },

            initializeExpensesAndTotalized(products, months) {
                console.log("📢 Inicializando expenses en cada mes...");

                // Clonar los meses para no modificar el original
                let updatedMonths = JSON.parse(JSON.stringify(months));

                // Obtener listas de productos por tipo
                let historicalProducts = products.filter(p => p.type === "historical");
                let seasonalProducts = products.filter(p => p.type === "seasonal");

                // 📌 Crear objeto de totalizados por fuera de months
                let totalizedExpenses = {
                    historical: historicalProducts.map(p => ({
                        productName: p.name,
                        totalizedExpense: 0
                    })),
                    seasonal: seasonalProducts.map(p => ({
                        productName: p.name,
                        totalizedExpense: 0
                    }))
                };

                // Iterar sobre cada mes en cashFlowData.months
                updatedMonths.forEach(month => {
                    let monthName = month.name;

                    // Inicializar los arrays de expenses con 0
                    month.historicalExpenses = historicalProducts.map(p => ({
                        productName: p.name,
                        expenseTotal: 0
                    }));

                    month.seasonalExpenses = seasonalProducts.map(p => ({
                        productName: p.name,
                        expenseTotal: 0
                    }));

                    console.log(`✅ ${monthName}: ${historicalProducts.length} historicalExpenses y ${seasonalProducts.length} seasonalExpenses inicializados.`);
                });

                console.log("✅ Expenses inicializados correctamente.");
                console.log(updatedMonths);
                return { updatedMonths, totalizedExpenses };
            },
            assignExpensesToMonths(products, months) {
                console.log("📢 Asignando valores a expenses en cada mes...");

                // Clonar los meses para no modificar el original
                let updatedMonths = JSON.parse(JSON.stringify(months));

                // Obtener la lista de meses válidos
                let validMonths = updatedMonths.map(m => m.name);

                // Obtener listas separadas de productos
                let historicalProducts = products.filter(p => p.type === "historical");
                let seasonalProducts = products.filter(p => p.type === "seasonal");

                // Función para obtener el índice numérico de un mes
                function getMonthIndex(monthName) {
                    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
                                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                    return months.indexOf(monthName) + 1;
                }

                // Función para formatear una fecha en "Marzo/25"
                function formatMonthYear(dateStr) {
                    let date = new Date(dateStr);
                    let monthIndex = date.getUTCMonth();
                    let year = date.getUTCFullYear().toString().slice(-2);
                    const monthsArray = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
                                        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                    return `${monthsArray[monthIndex]}/${year}`;
                }

                // Función para obtener el siguiente mes basado en la periodicidad
                function getNextMonth(currentMonth, periodicity, validMonths) {
                    let [month, year] = currentMonth.split("/");
                    let monthIndex = getMonthIndex(month);
                    let fullYear = parseInt("20" + year);

                    let monthsToAdd = {
                        "Mensual": 1,
                        "Bimensual": 2,
                        "Trimestral": 3,
                        "Semestral": 6,
                        "Anual": 12
                    }[periodicity] || 1;

                    monthIndex += monthsToAdd;
                    if (monthIndex > 12) {
                        monthIndex -= 12;
                        fullYear += 1;
                    }

                    let monthsArray = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
                                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                    let nextMonthName = monthsArray[monthIndex - 1];
                    let nextMonth = `${nextMonthName}/${String(fullYear).slice(-2)}`;

                    return validMonths.includes(nextMonth) ? nextMonth : null;
                }

                // Iterar sobre cada producto
                products.forEach(product => {
                    let expenseType = product.type === "seasonal" ? "seasonalExpenses" : "historicalExpenses";

                    product.expenses.forEach(expense => {
                        let startDate = new Date(expense.expenseDate);
                        let expenseTotal = parseInt(expense.expenseTotal);
                        let periodicity = expense.expensePeriodicity;

                        console.log(`🛠️ Procesando gasto: ${expense.expenseName} | Tipo: ${expenseType} | Fecha Inicio: ${startDate} | Periodicidad: ${periodicity}`);

                        // 🔹 Caso especial: "Seleccionar mes"
                        if (periodicity === "Seleccionar mes") {
                            let selectedMonth = formatMonthYear(expense.expensePeriodicityDate); // Convertimos la fecha a "Marzo/25"

                            if (validMonths.includes(selectedMonth)) {
                                let targetMonth = updatedMonths.find(m => m.name === selectedMonth);
                                let productIndexInType = (product.type === "seasonal") 
                                    ? seasonalProducts.findIndex(p => p.name === product.name) 
                                    : historicalProducts.findIndex(p => p.name === product.name);

                                if (productIndexInType !== -1) {
                                    targetMonth[expenseType][productIndexInType].expenseTotal += expenseTotal;
                                    console.log(`💰 ${expense.expenseName} agregado a ${selectedMonth} para ${product.name} con valor ${expenseTotal}`);
                                } else {
                                    console.warn(`⚠️ Producto ${product.name} no encontrado en ${expenseType}.`);
                                }
                            } else {
                                console.warn(`⚠️ Mes seleccionado (${selectedMonth}) no es válido en cashFlowData.`);
                            }
                            return; // No seguir con la lógica de periodicidad, solo se asigna en el mes seleccionado
                        }

                        // 🔹 Para periodicidades normales
                        let firstValidMonth = validMonths.find(m => {
                            let [month, year] = m.split("/");
                            let monthIndex = getMonthIndex(month);
                            let fullYear = parseInt("20" + year);
                            return new Date(fullYear, monthIndex - 1, 1) >= startDate;
                        });

                        if (!firstValidMonth) {
                            console.warn(`⚠️ No se encontró un mes válido para el gasto ${expense.expenseName}. Se ignora.`);
                            return;
                        }

                        console.log(`✅ Primer mes válido para el gasto ${expense.expenseName}: ${firstValidMonth}`);

                        // Iterar por meses según periodicidad y asignar gastos
                        let currentMonth = firstValidMonth;
                        while (currentMonth) {
                            let targetMonth = updatedMonths.find(m => m.name === currentMonth);
                            if (!targetMonth) break;

                            let productIndexInType = (product.type === "seasonal") 
                                ? seasonalProducts.findIndex(p => p.name === product.name) 
                                : historicalProducts.findIndex(p => p.name === product.name);

                            if (productIndexInType !== -1) {
                                targetMonth[expenseType][productIndexInType].expenseTotal += expenseTotal;
                                console.log(`💰 ${expense.expenseName} agregado a ${currentMonth} para ${product.name}`);
                            } else {
                                console.warn(`⚠️ Producto ${product.name} no encontrado en ${expenseType}.`);
                            }

                            // Encontrar el siguiente mes según periodicidad
                            currentMonth = getNextMonth(currentMonth, periodicity, validMonths);
                        }
                    });
                });

                console.log("✅ Expenses asignados correctamente.");
                console.log(updatedMonths);
                return updatedMonths;
            },

            syncProducts() {
                // Crear un mapa de los productos existentes por nombre
                const existingProductsMap = new Map(
                    this.products.map(product => [product.name, product])
                );

                // Revisar seasonalSales
                this.seasonalSales.forEach(seasonal => {
                    if (!existingProductsMap.has(seasonal.seasonalName)) {
                        // Agregar producto nuevo
                        this.products.push({
                            name: seasonal.seasonalName,
                            type: "seasonal",
                            data: seasonal,
                            expenses: [],
                            expenseTotal: 0
                        });
                    }
                });

                // Revisar historicalYields
                this.historicalYields.forEach(historical => {
                    if (!existingProductsMap.has(historical.historicalName)) {
                        // Agregar producto nuevo
                        this.products.push({
                            name: historical.historicalName,
                            type: "historical",
                            data: historical,
                            expenses: [],
                            expenseTotal: 0
                        });
                    }
                });
            },
            generateProducts() {
                // Reiniciar el array de productos
                this.products = [];

                // Procesar seasonalSales
                this.seasonalSales.forEach(seasonal => {
                    this.products.push({
                        name: seasonal.seasonalName, // Extrae el nombre
                        type: "seasonal",            // Etiqueta opcional para distinguir
                        data: seasonal,              // Incluye los datos originales como referencia
                        expenses: [],                // Inicializa el array de gastos vacío
                        expenseTotal: 0              // Total inicializado en 0
                    });
                });

                // Procesar historicalYields
                this.historicalYields.forEach(historical => {
                    this.products.push({
                        name: historical.historicalName, // Extrae el nombre
                        type: "historical",              // Etiqueta opcional para distinguir
                        data: historical,                // Incluye los datos originales como referencia
                        expenses: [],                    // Inicializa el array de gastos vacío
                        expenseTotal: 0                  // Total inicializado en 0
                    });
                });
            },
            updateTotalExpenses(){
                // Suponiendo que this.products es un array de productos
                this.products.forEach(product => {
                    if (Array.isArray(product.expenses) && product.expenses.length > 0) {
                        // Suma el expenseTotal de todos los expenses dentro de este producto
                        product.expenseTotal = product.expenses.reduce((total, expense) => {
                            return total + (expense.expenseTotal || 0);
                        }, 0);
                    } else {
                        // Si no hay expenses, asignar 0
                        product.expenseTotal = 0;
                    }
                });
            },
            handleExpandChange(row, expanded) {
                this.currentRow = row;
                this.currentExpenseRow = null;
            },
            handleExpenseExpandChange(row, expanded) {
                this.currentExpenseRow = row;
            },
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            formatDate(date) {
                if (!date) return '';
                const formattedDate = new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit'
                });
                return formattedDate;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            handleCurrentExpenseChange(currentRow, oldCurrentRow) {
                this.currentExpenseRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        console.log(this.products[this.addProductIndex]);
                        this.products[this.addProductIndex].expenses.push({
                            expenseName: this.expenseName,
                            expenseQty: parseFloat(this.expenseQty) || 0,
                            expenseValue: parseFloat(this.expenseValue) || 0,
                            expenseTotal: parseFloat(this.expenseTotal) || 0,
                            expensePeriodicity: this.expensePeriodicity,
                            expensePeriodicityDate: this.expensePeriodicityDate,
                            expenseDate: this.expenseDate
                        })
                        this.updateTotalExpenses();
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Egreso agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.expenseName = '';
                this.expenseQty = '';
                this.expenseValue = '';
                this.expenseTotal = '';
                this.expensePeriodicity = '';
                this.expensePeriodicityDate = '';
                this.expenseDate = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod (index, row) {
                let expenseIndex = this.products[index].expenses.indexOf(this.currentExpenseRow);
                this.expenseName =  this.products[index].expenses[expenseIndex].expenseName;
                this.expenseQty =  this.products[index].expenses[expenseIndex].expenseQty;
                this.expenseValue =  this.products[index].expenses[expenseIndex].expenseValue;
                this.expenseTotal =  this.products[index].expenses[expenseIndex].expenseTotal;
                this.expensePeriodicity =  this.products[index].expenses[expenseIndex].expensePeriodicity;
                this.expensePeriodicityDate = this.products[index].expenses[expenseIndex].expensePeriodicityDate;
                this.expenseDate =  this.products[index].expenses[expenseIndex].expenseDate;
                this.editProductIndex = index;
                this.editProduct = true;  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod (index) {
                this.products[index].expenses.splice(this.products[index].expenses.indexOf(this.currentExpenseRow),1);
                this.updateTotalExpenses();
                this.currentExpenseRow = null;
                this.$refs.expensesTable.setCurrentRow();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            var expenseIndex = this.products[index].expenses.indexOf(this.currentExpenseRow);
                            this.products[index].expenses[expenseIndex].expenseName = this.expenseName;
                            this.products[index].expenses[expenseIndex].expenseQty = parseFloat(this.expenseQty) || 0;
                            this.products[index].expenses[expenseIndex].expenseValue = parseFloat(this.expenseValue) || 0;
                            this.products[index].expenses[expenseIndex].expenseTotal = parseFloat(this.expenseTotal) || 0;
                            this.products[index].expenses[expenseIndex].expensePeriodicity = this.expensePeriodicity;
                            this.products[index].expenses[expenseIndex].expensePeriodicityDate = this.expensePeriodicityDate;
                            this.products[index].expenses[expenseIndex].expenseDate = this.expenseDate;
                            this.updateTotalExpenses();
                            this.resetProduct();
                            this.currentExpenseRow = null;
                            this.$refs.expensesTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Egreso editado correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (index,row) {
                this.addProductIndex = index;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.currentExpenseRow = null;
                this.$refs.expensesTable.setCurrentRow();
                this.editProduct = false;
                this.errors.clear();
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                const allExpensesDiligenciados = this.products.every(product => 
                    Array.isArray(product.expenses) && product.expenses.length > 0
                );

                if (!allExpensesDiligenciados) {
                    this.showNotificationError("Algunos ciclos no tienen gastos diligenciados.");
                    return;
                }
                else {
                    let { updatedMonths, totalizedExpenses } = this.initializeExpensesAndTotalized(this.products, this.cashFlowData.months);
                    updatedMonths = this.assignExpensesToMonths(this.products, updatedMonths);
                    totalizedExpenses = this.calculateTotalizedExpenses(updatedMonths, totalizedExpenses);
                    const payload = {
                        products: this.products,
                        months: updatedMonths,
                        totalizedExpenses: totalizedExpenses
                    };
                    this.$store.dispatch('setAgroExpenses', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/agro/labour');
                    });
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                document.addEventListener('wheel', (event) => {
                if (event.target.type === 'number') {
                    event.preventDefault();
                }
                }, { passive: false });
            });
            if (this.$store.state.isCustomer) {
                this.seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.seasonalSales || [];
                this.historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.historicalYields || [];
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.expenses) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.expenses;
                    this.syncProducts();
                }
                else {
                    this.generateProducts();
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                this.historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.historicalYields || [];
                this.seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.seasonalSales || [];
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.expenses) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.expenses;
                    this.syncProducts();
                }
                else{
                    this.generateProducts();
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                this.seasonalSales = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.seasonalSales || [];
                this.historicalYields = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.historicalYields || [];
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.expenses) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.expenses;
                    this.syncProducts();
                }
                else{
                    this.generateProducts();
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .top-right-button {
        position: absolute;
        top: 10px; /* Ajusta el espacio desde el borde superior */
        right: 10px; /* Ajusta el espacio desde el borde derecho */
    }
</style>
